module.exports = "<h4 class=\"action-title mb-0 mt-0\">{{t('actionLanAllowVpn.staticLabel')|e}}</h4>\n<p>{{yesNoVal(allowVpn)|e}}</p>\n";
